import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServicesService } from '../services.service';
import {environment} from '../../environments/environment';
import swal from 'sweetalert2';

@Component({
  selector: 'app-order-processing',
  templateUrl: './order-processing.component.html',
  styleUrls: ['./order-processing.component.css']
})
export class OrderProcessingComponent implements OnInit {
  apiBaseUrl: string          = environment.apiBaseUrl;
    header                    = 'l-header';
    navbar                    = 'l-navbar l-navbar_t-light l-navbar_expand js-navbar-sticky';
    checkoutId;

  constructor(private route: ActivatedRoute, private _service: ServicesService, private router: Router) { }

  ngOnInit() {
      this.route.queryParams.subscribe(params => {
          this.checkoutId = params['id'];
          // console.log('This is checkout Id ' + this.checkoutId);
      });

      this.createOrder();
      // document.getElementById("openModalButton").click();
  }

  createOrder() {
    const data = {'checkoutId': this.checkoutId};
    /*this._service.createOrder(data).subscribe((res: any) => {
        // console.log('createOrder res', res);
        this.router.navigate(['orderdetail'], { queryParams: { order_id: res.result, is_transcation : 1 } });
    });*/
  }

}



// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/order-processing/order-processing.component.ts